export var rdocConstructs = {
    name: 'RDoC',
    id: 'rdocConstructs',
    depth: 3,
    enableToInclueOtherTagToTopLevel: false,
    tags: [
        {
            name: 'Negative Valence Systems',
            id: 'yB5qFh',
            children: [
                {
                    name: 'Acute Threat ("Fear")',
                    id: 'Ny2qsf'
                },
                {
                    name: 'Potential Threat ("Anxiety")',
                    id: 'Qk6jc8'
                },
                {
                    name: 'Sustained Threat',
                    id: 'Sj9B6V'
                },
                {
                    name: 'Loss',
                    id: 'v5GqFt'
                },
                {
                    name: 'Frustrative Nonreward',
                    id: 'z8GCZ4'
                }
            ]
        },
        {
            name: 'Positive Valence Systems',
            id: 'f6FLp7',
            children: [
                {
                    name: 'Reward Responsiveness',
                    id: 'Au7j3t',
                    children: [
                        {
                            name: 'Reward Anticipation',
                            id: 'g6NqQt'
                        },
                        {
                            name: 'Initial Response to Reward',
                            id: 'eU7h3H'
                        },
                        {
                            name: 'Reward Satiation',
                            id: 'eK4536'
                        }
                    ]
                },
                {
                    name: 'Reward Learning',
                    id: 'Ki8Nhd',
                    children: [
                        {
                            name: 'Probabilistic and Reinforcement Learning',
                            id: 'j4Zm2v'
                        },
                        {
                            name: 'Reward Prediction Error',
                            id: 'Z9gvR4'
                        },
                        {
                            name: 'Habit - PVS',
                            id: 'Hq3gzc'
                        }
                    ]
                },
                {
                    name: 'Reward Valuation',
                    id: 's8Lw9B',
                    children: [
                        {
                            name: 'Reward (probability)',
                            id: 'vZ6SdW'
                        },
                        {
                            name: 'Delay',
                            id: 'Yx2MdT'
                        },
                        {
                            name: 'Effort',
                            id: 'My9gjf'
                        }
                    ]
                }
            ]
        },
        {
            name: 'Cognitive Systems',
            id: 'k5FRzP',
            children: [
                {
                    name: 'Attention',
                    id: 'eT8nMu'
                },
                {
                    name: 'Perception',
                    id: 'U5zRAL',
                    children: [
                        {
                            name: 'Visual Perception',
                            id: 'Es6rq2'
                        },
                        {
                            name: 'Auditory Perception',
                            id: 'Hg4y23'
                        },
                        {
                            name: 'Olfactory/Somatosensory/Multimodal/Perception',
                            id: 'hG9uWA'
                        }
                    ]
                },
                {
                    name: 'Declarative Memory',
                    id: 'gY2zUD'
                },
                {
                    name: 'Language',
                    id: 'Qs9Swv'
                },
                {
                    name: 'Cognitive Control',
                    id: 'mA42jW',
                    children: [
                        {
                            name: 'Goal Selection; Updating, Representation, and Maintenance ⇒ Focus 1 of 2 ⇒ Goal Selection',
                            id: 'y2Q6UM'
                        },
                        {
                            name: 'Goal Selection; Updating, Representation, and Maintenance ⇒ Focus 2 of 2 ⇒ Updating, Representation, and Maintenance',
                            id: 'j2GSaK'
                        },
                        {
                            name: 'Response Selection; Inhibition/Suppression ⇒ Focus 1 of 2 ⇒ Response Selection',
                            id: 'V9nN4Y'
                        },
                        {
                            name: 'Response Selection; Inhibition/Suppression ⇒ Focus 2 of 2 ⇒ Inhibition/Suppression',
                            id: 'wQ4uyZ'
                        },
                        {
                            name: 'Performance Monitoring',
                            id: 'gV28KY'
                        }
                    ]
                },
                {
                    name: 'Working Memory',
                    id: 'wJ2X6M',
                    children: [
                        {
                            name: 'Active Maintenance',
                            id: 'aD8gUt'
                        },
                        {
                            name: 'Flexible Updating',
                            id: 'iY7E24'
                        },
                        {
                            name: 'Limited Capacity',
                            id: 'm4JBw3'
                        },
                        {
                            name: 'Interference Control',
                            id: 'y8GM3k'
                        }
                    ]
                }
            ]
        },
        {
            name: 'Social Processes',
            id: 'zS3jgk',
            children: [
                {
                    name: 'Affiliation and Attachment',
                    id: 'V5bBiL'
                },
                {
                    name: 'Social Communication',
                    id: 'jV9GuM',
                    children: [
                        {
                            name: 'Reception of Facial Communication',
                            id: 'u6UpbD'
                        },
                        {
                            name: 'Production of Facial Communication',
                            id: 'w2XLs4'
                        },
                        {
                            name: 'Reception of Non-Facial Communication',
                            id: 'K7vN9U'
                        },
                        {
                            name: 'Production of Non-Facial Communication',
                            id: 'zN4kVQ'
                        }
                    ]
                },
                {
                    name: 'Perception and Understanding of Self',
                    id: 'j9H52B',
                    children: [
                        {
                            name: 'Agency',
                            id: 'tX3NKP'
                        },
                        {
                            name: 'Self-Knowledge',
                            id: 'E5w7qU'
                        }
                    ]
                },
                {
                    name: 'Perception and Understanding of Others',
                    id: 'd9QhLB',
                    children: [
                        {
                            name: 'Animacy Perception',
                            id: 'B4vrpa'
                        },
                        {
                            name: 'Action Perception',
                            id: 'j9PGtd'
                        },
                        {
                            name: 'Understanding Mental States',
                            id: 'Zn6dHY'
                        }
                    ]
                }
            ]
        },
        {
            name: 'Arousal and Regulatory Systems',
            id: 'W5rfu2',
            children: [
                {
                    name: 'Arousal',
                    id: 'Q8bdyG'
                },
                {
                    name: 'Circadian Rhythms',
                    id: 'Pg5jFJ'
                },
                {
                    name: 'Sleep-Wakefulness',
                    id: 'L6ruJR'
                }
            ]
        },
        {
            name: 'Sensorimotor Systems',
            id: 'k8NBxf',
            children: [
                {
                    name: 'Motor Actions',
                    id: 'fY5aR9',
                    children: [
                        {
                            name: 'Action, Planning and Selection',
                            id: 'tP84By'
                        },
                        {
                            name: 'Sensorimotor Dynamics',
                            id: 'N6bCjE'
                        },
                        {
                            name: 'Initiation',
                            id: 'F5rxEf'
                        },
                        {
                            name: 'Execution',
                            id: 'u2DHjQ'
                        },
                        {
                            name: 'Inhibition and Termination',
                            id: 'i5Zxw8'
                        }
                    ]
                },
                {
                    name: 'Agency and Ownership',
                    id: 'r4QSXa'
                },
                {
                    name: 'Habit - Sensorimotor',
                    id: 'h2DxcG'
                },
                {
                    name: 'Innate Motor Patterns',
                    id: 'wZ6JRY'
                }
            ]
        },
        {
            name: 'Others',
            id: 'N2z9Rs',
            children: [
                {
                    name: 'Unspecified',
                    id: 'J2gASy'
                }
            ]
        }
    ]
};
